<style lang="scss">
.site-tofu {
  border-radius: 0.5rem;
  position: relative;
  > .trigger {
    border-radius: 4px;
    box-shadow: 0 0 0 1px #dee3eb;
    padding: 0 16px;
    transition: all 0.3s;
    &.router-link-active {
      box-shadow: 0 0 0 2px #4dc2ff, 0px 3px 6px rgba(94, 117, 136, 0.15);
    }
  }
  .chart-node {
    height: 53px;
    padding: 10px 0;
    border-top: 1px solid rgba(235, 235, 235, 1);
    border-bottom: 1px solid rgba(235, 235, 235, 1);
  }
  h2 {
    display: flex;
    justify-content: space-between;
    margin: 00;
    padding: 10px 0;
    color: #2967cc;
    font-size: 16px;
    text-transform: uppercase;
    line-height: normal;
    i {
      color: #aab0b3;
    }
  }
  .count {
    display: flex;
    padding: 8px 0;
    justify-content: space-between;
    font-size: 14px;
    span {
      color: #5d6167;
    }
    b {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>

<template>
  <div class="site-tofu">
    <router-link class="trigger" :to="`/site/${site.id}`" tag="div">
      <h2>
        <span>{{site.name}}</span>
        <i v-ui-permission="'addSite'" class="el-icon-s-tools" @click="editSite(site)"></i>
      </h2>
      <div class="chart-node" v-loading="loading" ref="chartNode"></div>
      <div class="count">
        <span>今日UV：</span>
        <b>{{uv.count}} {{_.get(_.last(uvHistory),'count', '-')}}</b>
      </div>
    </router-link>
  </div>
</template>

<script>
import request from '@/utils/request.js'
import { getOnlyShowDomainListBySiteId } from '@/utils/tool.js'
import * as echarts from 'echarts/core'
import { LineChart } from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  LineChart,
  TooltipComponent,
  GridComponent,
  CanvasRenderer
])

export default {
  props: {
    site: Object
  },
  data () {
    return {
      uv: '-',
      uvHistory: [],
      loading: false
    }
  },
  methods: {
    async uvHistoryFn () {
      this.loading = true
      let hosts = getOnlyShowDomainListBySiteId(this.site.id)
      if (hosts.length < 1) {
        hosts = this.site.domainList
      }
      let res = await request.get('/site/uv-history', {
        params: {
          start: moment()
            .subtract(15, 'days')
            .format('YYYY-MM-DD'),
          groupBy: 'day',
          type: 'uv',
          hosts
        }
      })
      this.loading = false
      if (!this.$refs.chartNode) {
        return
      }
      if (res.data) {
        this.uvHistory = res.data
        var myChart = echarts.init(this.$refs.chartNode)

        // 指定图表的配置项和数据
        var option = {
          xAxis: {
            data: res.data.map(item => item.date),
            show: false,
            boundaryGap: false
          },
          grid: {
            left: -10,
            right: -10,
            bottom: 0,
            top: 0
          },
          tooltip: {
            show: true,
            trigger: 'axis',
            formatter (a, b, c, d) {
              let data = a[0].data
              let date = moment(a[0].name)
              return `<div>
                <div>${date.format('YYYY-MM-DD dddd')}</div>
                <div style="text-align:right;">UV: ${data}</div>
              </div>
              `
            }
          },
          yAxis: {
            show: false
          },
          series: [
            {
              name: 'UV',
              type: 'line',
              data: res.data.map(item => item.count),
              smooth: true,
              lineStyle: {
                width: 1.5,
                color: '#3ecd82'
              },
              itemStyle: {
                opacity: 0
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(61,204,128,0.128)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(61,204,128,0)'
                  }
                ])
              }
            }
          ]
        }

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option)
      }
    },
    editSite (site) {
      this.$emit('edit', site)
    }
  },
  mounted () {
    this.uvHistoryFn()
  }
}
</script>
